<template>
  <v-form @submit.prevent="submit"
          :disabled="form.busy">
    <v-select v-model="form.role"
              :items="teamRoles"
              @change="submit"
              item-value="id"
              item-text="name">
    </v-select>
  </v-form>
</template>
<script>
import {mapGetters} from 'vuex';
import {Form} from 'vform';
import userService from "../../../services/userService";
import DOMPurify from 'dompurify';

export default {
  props: {
    user: {
      type: Object,
      required: true,
    },
    team: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      form: new Form({
        role: this.team.pivot.role,
      }),
    }
  },
  computed: {
    ...mapGetters([
      'teamRoles',
    ])
  },
  methods: {
    submit() {
      this.form.startProcessing();
      userService.changeTeamRole(this.user.id, this.team.id, this.form.role)
        .then(() => {
          this.$toast.success(`Role changed to ${DOMPurify.sanitize(this.form.role)}.`)
          this.$emit('updated');
        })
        .catch(err => {
          this.$toast.error(`There was an error changing the role: ${DOMPurify.sanitize(err.message)}`)
        })
        .finally(() => {
          this.form.busy = false;
        })
    }
  }
}
</script>
